import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { Box, Typography,  IconButton, Table, TableBody, TableCell, TableRow, AppBar, Toolbar, TableHead, TableFooter, TablePagination, Grid  } from '@mui/material';
import SwipeableTabs from '../../../container/MUI/SwipeableTabs';
import { Close } from '@mui/icons-material';
import Currency from '../../common/Currency';
import Pagination from '../../../container/MUI/Pagination';
import StackedStatsIn from "../../Stats/StackedStatsIn"
import { firstDayOfYear, sortByDate } from '../../../utils/statsFunctions';
import Dialog from '../../common/Dialog';
import DatePicker from '../../common/DatePicker';

class PostSingle extends Component {
    state = { 
        page: 0,
        rowsPerPage: 10,
        incomes: [],
        advances: [],
        total: 0,
        totalDu: 0,
        openDetails: false, 
        selectedIncome: {},
        start_date: this.props.start_date || firstDayOfYear,
        end_date: this.props.end_date || new Date(),
    }
    componentDidMount = async () => {
        // if(isEmpty(this.props.INCOMES) ){
        //     await this.props.fetchIncomes()
        // }  
        // if(isEmpty(this.props.CATEGORIES.PARENT)){
        //     this.props.fetchParentCategories()
        // }
        // if(isEmpty(this.props.CATEGORIES.CHILD)){
        //     this.props.fetchChildCategories()
        // }
        // this.filterIncomes()
    }
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };


    filterIncomes = () => {
        const { INCOMES, post  } = this.props;
        const { start_date, end_date } = this.state;
        let filteredList = []
        let totalIncome = 0
        
        if ( !isEmpty(INCOMES) ) {
            filteredList = Object.values(INCOMES).filter( income => 
                income.income_post === post.post_id &&
                new Date(income.income_date) >= start_date &&
                new Date(income.income_date) <= end_date 
            )
        }

        let sortedList = sortByDate(filteredList, "income_date").reverse()
        // this.setState({
        //     incomes: sortedList,
        //     totalIncome
        // })
        filteredList.forEach(item => {
            totalIncome += item.income_amount;
            // totalDu += item.income_rest_to_pay
        })

        return {list: sortedList, totalIncome}
    }
    // filterIncomes = () => {
    //     const { INCOMES, post } = this.props;
    //     let filteredList = !isEmpty(INCOMES) ? Object.values(INCOMES).filter(item => item.income_post === post.post_id) : []
        
    //     console.log('====================================');
    //     console.log({filteredList});
    //     console.log('====================================');
    //     let total = 0
    //     let totalDu = 0
    //     filteredList.forEach(item => {
    //         total += item.income_amount;
    //         totalDu += item.income_rest_to_pay
    //     })

    //     this.setState({
    //         incomes: filteredList,
    //         total,
    //         totalDu,
    //     })
    // }


    displayIncomes = () => {
        const { rowsPerPage, page } = this.state;
        const { BANKS } = this.props;
        let incomes = this.filterIncomes()

        return [incomes.list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
            let bank = isEmpty(BANKS) ? {} : BANKS[item.income_bank]
            
            return (
                <TableRow 
                    hover
                    key={item.income_id}
                    // onClick={() => this.setState({openDetails: true, selectedIncome: item }) }
                >
                    <TableCell >
                        {new Date(item.income_date).toLocaleDateString('fr-FR')}
                    </TableCell>
                    <TableCell >{ bank && bank.bank_name}</TableCell>    
                    <TableCell>{item.income_desc}</TableCell>   
                    <TableCell><Currency value={item.income_amount} /></TableCell>                     
                    <TableCell>{item.income_payment_mode}</TableCell>   
                </TableRow>
            )
        }), incomes.list, incomes.totalIncome]
    }
    
    // displayIncomes = () => {
    //     const { rowsPerPage, page, incomes } = this.state;
    //     const { BANKS } = this.props;
        
    //     return incomes.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( item => {
    //         let bank = isEmpty(BANKS) ? {} : BANKS[item.income_bank]

    //         return (
    //             <TableRow 
    //                 hover
    //                 key={item.income_id}
    //                 // onClick={() => this.setState({openDetails: true, selectedIncome: item }) }
    //             >
    //                 <TableCell >{new Date(item.income_date).toLocaleDateString('fr-FR')}</TableCell>
    //                 <TableCell>{item.income_desc}</TableCell>   
    //                 <TableCell >{ bank && bank.bank_name}</TableCell>                     
    //                 <TableCell><Currency value={item.income_amount} /></TableCell>                     
    //                 {/* <TableCell>
    //                     {!item.income_fully_paid &&
    //                         <Currency value={item.income_rest_to_pay} /> rest_to_match
    //                     }
    //                 </TableCell>
    //                  */}
    //             </TableRow>
    //         )
    //     })
    // }
    render() {
        const { post, POSTS, BANKS } = this.props;
        const { rowsPerPage, page, total, totalDu, openDetails, selectedIncome} = this.state;
        let incomes = !isEmpty(BANKS) ? this.displayIncomes() : []

        return (
            <Dialog
                close={this.props.handleClose}
                maxWidth="lg"
                fullScreen
                scroll="paper"
                title={post.post_name}
                appBar
            >
                {/* {openDetails && selectedIncome && 
                    <IncomeDetails 
                        post={post} 
                        LABELS={LABELS}
                        BANKS={BANKS}
                        PAYMENTS={PAYMENTS}
                        category={CATEGORIES.CHILD && CATEGORIES.CHILD[selectedIncome.income_category]} 
                        income={selectedIncome} 
                        view={"ADMIN"}
                        handleClose={()=> this.setState({openDetails: false, selectedIncome: {}})}
                        fetchIncomePayments={this.props.fetchIncomePayments}
                    />
                } */}                    
                <Box>
                    <Grid container>
                        <Grid item xs={12} sm={6} >
                            <DatePicker
                                required
                                label="Du"
                                handleChange={(date)=> this.setState({ start_date: date})}
                                value={this.state.start_date}
                                id="start_date"
                                maxDate={this.state.end_date || new Date()}

                            />
                        </Grid>
                        <Grid item xs={12} sm={6} >
                            <DatePicker
                                required
                                label="Au"
                                handleChange={(date)=> this.setState({ end_date: date})}
                                value={this.state.end_date}
                                id="end_date"
                                maxDate={new Date()}
                                minDate={this.state.start_date || new Date()}
                            />
                        </Grid>
                    </Grid>
                    <SwipeableTabs
                        tab={this.props.tab}
                        labels={["Statistiques", "Recettes"]}
                        
                    >
                        <Box p={3}>
                            {/* Total: <Currency value={total} /> <br/> */}
                            {/* Reste à Payer: <Currency value={totalDu} /> */}
                            <StackedStatsIn
                                // budget_year={this.props.budget_year}
                                BANKS={BANKS}
                                POSTS={POSTS}
                                INCOMES={incomes[1]}
                                fieldBy="income_bank"
                                fieldName="bank_name" 
                                post
                                {...this.state}
                            />
                        </Box>
                        <Box p={3}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Créé le</TableCell>
                                        <TableCell>Description</TableCell>
                                        <TableCell>Banque</TableCell>
                                        <TableCell>Montant</TableCell>
                                        <TableCell>Mode</TableCell>
                                        {/* <TableCell>Reste à Payer</TableCell> */}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {incomes[0]}
                                </TableBody>
                                {size(incomes[1]) > 10 &&
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                rowsPerPageOptions={[10, 30]}
                                                labelRowsPerPage="Lignes par Page"
                                                colSpan={6}
                                                count={size(incomes[1])}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                SelectProps={{
                                                    native: true,
                                                }}
                                                onPageChange={this.handleChangePage}
                                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                                ActionsComponent={Pagination}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                }
                            </Table>
                        </Box>
                    </SwipeableTabs>
                </Box>
            </Dialog>
        );
    }
}

export default PostSingle;